import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { Panel } from "@/components/common";

export default function PaymentResult({ outcome }) {
  const { t } = useLang();
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState(outcome === "cancel" ? "cancel" : "checking");

  useEffect(() => {
    if (outcome !== "success" || !sessionId) return;
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") return setState("paid");
        if (["failed", "expired"].includes(data.payment_status)) return setState("cancel");
      } catch {}
      if (++tries < 6) timer = setTimeout(poll, 2000);
      else setState("pending");
    };
    poll();
    return () => clearTimeout(timer);
  }, [outcome, sessionId]);

  const views = {
    checking: [Loader2, "animate-spin text-slate-400", t("payChecking"), ""],
    paid: [CheckCircle2, "text-[#007A3D]", t("paySuccess"), t("paySuccessText")],
    pending: [Loader2, "text-amber-500", t("paySuccess"), t("payPending")],
    cancel: [XCircle, "text-[#CE1126]", t("payCancelled"), t("payCancelledText")],
  };
  const [Icon, cls, title, text] = views[state];
  return (
    <div className="mx-auto max-w-md pt-10" data-testid={`payment-${state}`}>
      <Panel className="p-8 text-center">
        <Icon className={`mx-auto h-12 w-12 ${cls}`} />
        <h1 className="mt-4 font-display text-2xl font-extrabold text-slate-900">{title}</h1>
        {text && <p className="mt-2 text-sm text-slate-500">{text}</p>}
        <Link data-testid="payment-back-link" to="/settings" className="mt-6 inline-block rounded-full bg-[#007A3D] px-5 py-2 text-sm font-bold text-white hover:bg-[#005E2E]">{t("backToBilling")}</Link>
      </Panel>
    </div>
  );
}
